import * as React from 'react'

const SvgAllCoursesIcon = (props) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5835 13V3.66667C5.5835 3.04669 5.5835 2.7367 5.65164 2.48236C5.83658 1.79218 6.37567 1.25308 7.06586 1.06815C7.32019 1 7.63018 1 8.25016 1C8.87014 1 9.18013 1 9.43447 1.06815C10.1247 1.25308 10.6637 1.79218 10.8487 2.48236C10.9168 2.7367 10.9168 3.04669 10.9168 3.66667V13M3.71683 13H12.7835C13.5302 13 13.9036 13 14.1888 12.8547C14.4397 12.7268 14.6437 12.5229 14.7715 12.272C14.9168 11.9868 14.9168 11.6134 14.9168 10.8667V5.8C14.9168 5.05326 14.9168 4.6799 14.7715 4.39468C14.6437 4.1438 14.4397 3.93982 14.1888 3.81199C13.9036 3.66667 13.5302 3.66667 12.7835 3.66667H3.71683C2.97009 3.66667 2.59672 3.66667 2.31151 3.81199C2.06063 3.93982 1.85665 4.1438 1.72882 4.39468C1.5835 4.6799 1.5835 5.05326 1.5835 5.8V10.8667C1.5835 11.6134 1.5835 11.9868 1.72882 12.272C1.85665 12.5229 2.06063 12.7268 2.31151 12.8547C2.59672 13 2.97009 13 3.71683 13Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgAllCoursesIcon
